var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    _vm._g(_vm._b({}, "el-dialog", _vm.$attrs, false), _vm.$listeners),
    [
      _c(
        "div",
        { staticClass: "sync-sty" },
        [
          _c(
            "el-card",
            {
              staticClass: "box-card",
              class: { active: _vm.orgSyncType == 1 },
              nativeOn: {
                click: function($event) {
                  return _vm.dingSync.apply(null, arguments)
                }
              }
            },
            [
              _c("img", {
                staticClass: "icon-sty",
                attrs: { src: "/images/icon/dingIcon1.png", alt: "icon" }
              }),
              _c("h2", { staticStyle: { margin: "5px 0" } }, [
                _vm._v("同步钉钉组织架构")
              ]),
              _c("p", { staticClass: "text-sty" }, [
                _vm._v(
                  "实现钉钉组织架构单向同步，仅需在钉钉端维护组织架构信息；在钉钉端执行部门新增、修改或删除操作后，君子签系统将自动同步并完成对应调整。"
                )
              ])
            ]
          ),
          _c(
            "el-card",
            {
              staticClass: "box-card",
              class: { active: _vm.orgSyncType == 2 },
              nativeOn: {
                click: function($event) {
                  return _vm.selfManage.apply(null, arguments)
                }
              }
            },
            [
              _c("img", {
                staticClass: "icon-sty",
                attrs: { src: "/images/logoNew.png", alt: "" }
              }),
              _c("h2", { staticStyle: { margin: "5px 0" } }, [
                _vm._v("自行管理组织架构")
              ]),
              _c("p", { staticClass: "text-sty" }, [
                _vm._v(
                  "将基于自身现有组织架构进行独立管理与维护，其组织架构数据与钉钉相互隔离。钉钉端对部门的增删改操作，均不会对组织架构产生任何影响。"
                )
              ])
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d39ad51", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d39ad51","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/console/memberManage/components/syncOrganPup.vue
// module id = JM7S
// module chunks = 7 40